/** Garen AbilitySpec seed kit. */
export const GAREN_ABILITY_DEFS = [
  {
    id: 'garen_q',
    champKey: 'garen',
    slot: 'Q',
    name: 'Golpe Decisivo',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 8,
    manaCost: 0,
    vfxId: 'garen_q',
    status: 'wired'
  },
  {
    id: 'garen_w',
    champKey: 'garen',
    slot: 'W',
    name: 'Coraje',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 22,
    manaCost: 0,
    vfxId: 'garen_w',
    status: 'wired'
  },
  {
    id: 'garen_e',
    champKey: 'garen',
    slot: 'E',
    name: 'Juicio',
    targeting: 'aoe_self',
    range: 325,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 325,
    cooldown: 9,
    manaCost: 0,
    vfxId: 'garen_e',
    duration: 3,
    status: 'wired'
  },
  {
    id: 'garen_r',
    champKey: 'garen',
    slot: 'R',
    name: 'Justicia Demaciana',
    targeting: 'targeted',
    range: 400,
    castTime: 0.435,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    manaCost: 0,
    vfxId: 'garen_r',
    status: 'wired'
  }
];
